export const msalConfig = {
    auth: {
        clientId: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_CLIENT_ID : window.APP_ENV_CONFIG.AzureAd.clientId,
        authority: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_AUTHORITY : window.APP_ENV_CONFIG.AzureAd.authority,
        redirectUri: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_REDIRECT_URI : window.APP_ENV_CONFIG.AzureAd.redirectUri,
        postLogoutRedirectUri: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI : window.APP_ENV_CONFIG.AzureAd.postLogoutRedirectUri,
        validateAuthority: false,
        navigateToLoginRequestUrl:false,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    lastToken: "Not_Set_Yet"
};

export const funcAppUrl = useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_FUNCTION_APP_URL : window.APP_ENV_CONFIG.AzureAd.funcAppUrl;
export const funcApiKey = useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_AZURE_FUNC_API_KEY : window.APP_ENV_CONFIG.AzureAd.funcApiKey;
export const loginRequest = { scopes: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_AUTH_SCOPES.split(',') : window.APP_ENV_CONFIG.AzureAd.loginRequest.toString().split(',')};
export const accessRequest = { scopes: useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? process.env.REACT_APP_ACCESS_SCOPES.split(',') : window.APP_ENV_CONFIG.AzureAd.accessRequest.toString().split(',')};
export const environment = useDeveloperConfiguration(window.APP_ENV_CONFIG.Environment) ? 'local' : window.APP_ENV_CONFIG.Environment;

function useDeveloperConfiguration(envValue)
{
    // use the .env.development file if the placeholder is still present or the env is 'local'
    return !envValue || envValue.startsWith('#{') || envValue === 'local';
}



// WEBPACK FOOTER //
// ./src/provider/authConfig.js